module.exports = __webpack_public_path__ + "images/panorama-360-1-5aca9dc937505c393fb5c3bcd778fdea.jpg";